var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  currentOrders\n\n  "),_c('ag-table',{attrs:{"data-source-api":_vm.getAll,"grid-options":_vm.gridOptions,"permissions":_vm.permissions,"rtl":false},on:{"emitExportToExcel":_vm.exportToExcel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }